// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalContainer_container__oGGlI","opened":"ModalContainer_opened__3hpyk"};